import { render, staticRenderFns } from "./FlexContainer.vue?vue&type=template&id=7bd3eaa8&scoped=true&"
import script from "./FlexContainer.vue?vue&type=script&lang=js&"
export * from "./FlexContainer.vue?vue&type=script&lang=js&"
import style0 from "./FlexContainer.vue?vue&type=style&index=0&id=7bd3eaa8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd3eaa8",
  null
  
)

export default component.exports